<template>
    <v-container fluid>
        <v-card
            class="ma-8"
        >
            <v-card-text>
                <p class="display-1 text--primary">
                    Welcome to VRS 2.0
                </p>
                <p>Please, select one of the options on the main menu to get started.</p>
            </v-card-text>
            <v-card-actions>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>